<template>
  <div
    :data-field="name"
    :id="name"
    :class="[
      'form-item-wrap',
      marginBottom ? 'bottom' : '',
      noPadding ? 'noPadding' : '',
      'with-switch',
      { noPaddingTop: noPaddingTop },
      { borderRadiusTop: borderRadiusTop },
      { borderRadiusBottom: borderRadiusBottom },
    ]"
  >
    <div class="form-item-inner-wrap">
      <div :class="['form-item-label', 'with-switch', isSwitchOn ? 'bottom' : '']" v-if="label">
        <div class="label-text-wrap">
          <span class="form-item-asterisk" v-if="asterisk">*</span>
          <label class="form-item-label-text">{{ label }}</label>
        </div>
        <div class="label-icon" v-if="icon">
          <i :class="icon"></i>
        </div>
      </div>
      <div class="form-item-extra" v-if="extra">{{ extra }}</div>
      <div class="form-item-content">
        <slot />
      </div>
    </div>
    <div class="form-item-arrow" v-if="arrow">
      <i class="crm-Icon_right"></i>
    </div>
  </div>
</template>

<script>
import { EventBus } from './utils'

export default {
  data () {
    return {
      isSwitchOn: true
    }
  },
  props: {
    name: {},
    asterisk: {},
    error: {},
    label: {},
    extra: {},

    icon: {},
    arrow: {},
    marginBottom: {},
    noPadding: {},
    noPaddingTop: {},
    borderRadiusTop: {},
    borderRadiusBottom: {},
    direction: {} // 'vertical' | 'horizontal'
  },
  created () {
    const me = this
    // 监听 slot 的事件不能监听 @change，只能通过 EvenBus
    EventBus.$on('change', (value) => {
      me.isSwitchOn = value
    })
  },
  destroyed () {
    EventBus.$off('change')
  }
}
</script>
<style lang="scss">
@import "./style.scss"
</style>
